/* NSA — Nonna Silvi Analytics. Tracker comportamentale first-party.
   Zero dipendenze, consent-gated (Shopify Customer Privacy), no cookie, no PII.
   Config da window.__NSA = { endpoint, rrwebSrc, country } (vedi snippets/nsa-tracker.liquid). */
(function () {
  'use strict';
  var CFG = window.__NSA;
  if (!CFG || !CFG.endpoint) return;

  /* ---------- sid: uuid4 in sessionStorage (niente cookie) ---------- */
  function uuid4() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16);
    crypto.getRandomValues(b);
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function ss(k, v) { // sessionStorage safe (Safari private mode ecc.)
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  var SID = ss('nsa_sid');
  if (!SID) { SID = uuid4(); ss('nsa_sid', SID); }

  /* ---------- coda eventi + flush batch ---------- */
  var queue = [];
  var metaSent = false;
  function push(t, d) {
    queue.push({ t: t, ts: Date.now(), page: location.pathname, d: d || {} });
  }
  function buildMeta() {
    var ref = '';
    try { if (document.referrer) ref = new URL(document.referrer).host; } catch (e) {}
    var q = location.search;
    function utm(k) { var m = q.match(new RegExp('[?&]utm_' + k + '=([^&]*)')); return m ? decodeURIComponent(m[1]).slice(0, 80) : ''; }
    return {
      lang: navigator.language || '',
      vw: window.innerWidth,
      ua_mobile: /Mobi|Android/i.test(navigator.userAgent),
      ref: ref,
      utm: { source: utm('source'), medium: utm('medium'), campaign: utm('campaign') },
      landing: location.pathname,
      country_hint: CFG.country || ''
    };
  }
  function flush(beacon) {
    // Il backend accetta max 50 eventi/batch (gli extra verrebbero scartati
    // in silenzio): spezzettiamo la coda in batch da 50.
    while (queue.length) {
      var body = { sid: SID, page: location.pathname, events: queue.splice(0, 50) };
      if (!metaSent) { body.meta = buildMeta(); metaSent = true; }
      var json = JSON.stringify(body);
      var url = CFG.endpoint + '/collect.php';
      if (beacon && navigator.sendBeacon) {
        navigator.sendBeacon(url, json); // text/plain: il backend lo accetta
      } else {
        try {
          fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: json }).catch(function () {});
        } catch (e) {}
      }
    }
  }

  /* ---------- selettore compatto per i click ---------- */
  function sel(el) {
    if (!el || !el.tagName) return '';
    var s = el.tagName.toLowerCase();
    if (el.id) s += '#' + el.id;
    var c = (typeof el.className === 'string' ? el.className : '').trim().split(/\s+/).filter(Boolean).slice(0, 2);
    if (c.length) s += '.' + c.join('.');
    return s.slice(0, 120);
  }
  function txt(el) {
    return ((el.innerText || el.textContent || '')).trim().replace(/\s+/g, ' ').slice(0, 40);
  }
  var INTER = /^(A|BUTTON|INPUT|SELECT|TEXTAREA|LABEL|SUMMARY)$/;
  function interactive(el) {
    return INTER.test(el.tagName) || el.hasAttribute('onclick') || el.getAttribute('role') === 'button';
  }
  function isDead(el) { // nessun elemento interattivo: target + 3 livelli di ancestor
    var n = el;
    for (var i = 0; i <= 3 && n && n.tagName; i++) {
      if (n.tagName === 'BODY' || n.tagName === 'HTML') break;
      if (interactive(n)) return false;
      n = n.parentElement;
    }
    return el.tagName !== 'BODY' && el.tagName !== 'HTML';
  }

  /* ---------- stato pagina (reset su SPA-nav) ---------- */
  var scrollFired = {};
  function resetPage() { scrollFired = {}; }

  /* ---------- recording rrweb (sampling, consent-gated) ---------- */
  // Il contatore chunk DEVE sopravvivere ai page load (stesso sid per tutta la
  // sessione): se ripartisse da 0 a ogni pagina, il chunk 0 della pagina nuova
  // sovrascriverebbe quello della pagina precedente (UNIQUE(sid,chunk) lato server).
  var rec = { on: false, started: false, buf: [], chunk: parseInt(ss('nsa_chunkn') || '0', 10) || 0, stopFn: null, timer: null, t0: 0 };
  function recDecision() {
    var v = ss('nsa_rec');
    if (v === '1') return true;
    if (v === '0') return false;
    var on = /\/cart|\/pages\/madamadore/.test(location.pathname) || Math.random() < 0.15;
    ss('nsa_rec', on ? '1' : '0');
    return on;
  }
  function startRecording() {
    if (rec.started || !CFG.rrwebSrc) return;
    if (rec.chunk >= 30) return; // limite sessione già raggiunto su pagine precedenti
    rec.started = true;
    ss('nsa_rec', '1');
    var s = document.createElement('script');
    s.src = CFG.rrwebSrc;
    s.onload = function () {
      var g = window.rrwebRecord;
      var fn = g && (typeof g === 'function' ? g : g.record);
      if (typeof fn !== 'function') return;
      rec.t0 = Date.now();
      try {
        rec.stopFn = fn({
          emit: function (ev) { rec.buf.push(ev); },
          maskAllInputs: true,            // niente PII nei replay
          blockSelector: 'iframe,.nsa-block'
        });
      } catch (e) { return; }
      rec.timer = setInterval(function () { flushRec(false); }, 10000);
    };
    document.head.appendChild(s);
  }
  function stopRecording() {
    if (rec.stopFn) { try { rec.stopFn(); } catch (e) {} rec.stopFn = null; }
    if (rec.timer) { clearInterval(rec.timer); rec.timer = null; }
  }
  function postChunk(body, n, keepalive) {
    try {
      fetch(CFG.endpoint + '/record.php', {
        method: 'POST', keepalive: !!keepalive,
        headers: { 'X-NSA-SID': SID, 'X-NSA-CHUNK': String(n) },
        body: body
      }).catch(function () {});
    } catch (e) {}
  }
  function flushRec(beacon) {
    if (!rec.buf.length) return;
    var payload = JSON.stringify(rec.buf.splice(0));
    var n = rec.chunk++;
    ss('nsa_chunkn', String(rec.chunk)); // persisti il contatore tra page load
    // gzip con CompressionStream se disponibile, altrimenti raw (il backend rileva i magic bytes)
    if (!beacon && window.CompressionStream && window.Response) {
      try {
        new Response(new Blob([payload]).stream().pipeThrough(new CompressionStream('gzip')))
          .arrayBuffer().then(function (buf) { postChunk(buf, n, false); });
      } catch (e) { postChunk(payload, n, false); }
    } else {
      postChunk(payload, n, beacon); // su pagehide: raw + keepalive (gzip async non affidabile)
    }
    // limiti: 5 minuti o 30 chunk per sessione
    if (rec.chunk >= 30 || Date.now() - rec.t0 > 300000) stopRecording();
  }
  function maybeRecordNow() { // attivazione on-the-fly al primo cart_add / js_error
    if (booted && !rec.started) startRecording();
  }

  /* ---------- avvio (post-consenso) ---------- */
  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;

    push('pageview', {});

    /* SPA-nav: hook su pushState/replaceState + popstate */
    var lastPath = location.pathname;
    function onNav() {
      if (location.pathname === lastPath) return;
      lastPath = location.pathname;
      resetPage();
      push('pageview', {});
    }
    ['pushState', 'replaceState'].forEach(function (m) {
      var orig = history[m];
      if (!orig) return;
      history[m] = function () { var r = orig.apply(this, arguments); onNav(); return r; };
    });
    window.addEventListener('popstate', onNav);

    /* click + rage_click + dead_click + cart_add (throttle 10/s) */
    var clickCount = 0, recent = [];
    setInterval(function () { clickCount = 0; }, 1000);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.tagName) return;

      // cart_add: bottoni add-to-cart o submit di form /cart/add
      var btn = t.closest && t.closest('[name="add"],.product-form__submit,button,input[type="submit"]');
      if (btn) {
        var isAdd = btn.matches('[name="add"],.product-form__submit');
        if (!isAdd && btn.form && /\/cart\/add/.test(btn.form.getAttribute('action') || '')) isAdd = true;
        if (isAdd) { push('cart_add', { sel: sel(btn), text: txt(btn) }); maybeRecordNow(); }
      }

      // rage_click: >=3 click in 800ms entro raggio 24px
      var now = Date.now();
      recent = recent.filter(function (c) { return now - c.t < 800; });
      recent.push({ x: e.clientX, y: e.clientY, t: now });
      var near = recent.filter(function (c) {
        return Math.abs(c.x - e.clientX) <= 24 && Math.abs(c.y - e.clientY) <= 24;
      });
      if (near.length === 3) push('rage_click', { sel: sel(t), n: near.length });

      if (clickCount >= 10) return; // throttle
      clickCount++;
      push('click', { sel: sel(t), text: txt(t) });
      if (isDead(t)) push('dead_click', { sel: sel(t) });
    }, true);

    /* scroll_depth: milestone 25/50/75/90 una volta per pagina */
    var scrollTick = false;
    window.addEventListener('scroll', function () {
      if (scrollTick) return;
      scrollTick = true;
      setTimeout(function () {
        scrollTick = false;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h <= 0) return;
        var pct = (window.scrollY / h) * 100;
        [25, 50, 75, 90].forEach(function (m) {
          if (pct >= m && !scrollFired[m]) { scrollFired[m] = 1; push('scroll_depth', { depth: m }); }
        });
      }, 250);
    }, { passive: true });

    /* time_on_page: somma dei ms con tab visibile */
    var visMs = 0, visStart = document.visibilityState === 'visible' ? Date.now() : 0;
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        if (visStart) { visMs += Date.now() - visStart; visStart = 0; }
        flush(true); // opportunistic flush quando il tab va in background
      } else if (!visStart) visStart = Date.now();
    });

    /* js_error: max 5 per sessione */
    function pushErr(msg, src) {
      var n = parseInt(ss('nsa_errc') || '0', 10);
      if (n >= 5) return;
      ss('nsa_errc', String(n + 1));
      push('js_error', { msg: String(msg).slice(0, 200), src: String(src || '').slice(0, 200) });
      maybeRecordNow();
    }
    window.addEventListener('error', function (e) {
      pushErr(e.message || 'error', (e.filename || '') + ':' + (e.lineno || 0));
    });
    window.addEventListener('unhandledrejection', function (e) {
      var r = e.reason;
      pushErr((r && (r.message || r)) || 'unhandledrejection', '');
    });

    /* form_abandon: focus su campo form + pagehide senza submit */
    var openForms = {};
    document.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!t || !/^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName)) return;
      var f = t.closest && t.closest('form');
      if (f) openForms[sel(f) || 'form'] = 1;
    });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.tagName === 'FORM') delete openForms[sel(f) || 'form'];
    }, true);

    /* pagehide: time_on_page + form_abandon + exit + flush finale */
    window.addEventListener('pagehide', function () {
      if (visStart) { visMs += Date.now() - visStart; visStart = 0; }
      push('time_on_page', { ms: visMs });
      Object.keys(openForms).forEach(function (k) { push('form_abandon', { form: k }); });
      openForms = {};
      push('exit', { page: location.pathname });
      flush(true);
      flushRec(true);
    });

    /* flush periodico ogni 5s */
    setInterval(function () { flush(false); }, 5000);

    /* recording: decisione una volta per sessione */
    if (recDecision()) startRecording();
  }

  /* ---------- CONSENT GATE ----------
     Parte solo con consenso analytics (Shopify Customer Privacy API).
     Override di test: ?nsa_test=1 in URL parte comunque (verifica pre-banner).
     Se l'API non esiste: non parte (boot solo via evento visitorConsentCollected). */
  var testMode = /[?&]nsa_test=1/.test(location.search);
  function consentOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }
  if (testMode) {
    boot();
  } else if (consentOk()) {
    boot();
  } else {
    document.addEventListener('visitorConsentCollected', function () {
      if (consentOk()) boot();
    });
  }
})();
